<template lang="pug">
  v-card(
    v-if="chart.type"
    class="pa-1"
    color="white"
    outline
  )
    GChart(
      v-if="!isLoadingData"
      :type="chart.type"
      :data="chart.data"
      :options="chart.options",
      :events="{click: $event => redirectChart($event, chart)}"
    )
    v-row(v-if="isLoadingData")
      v-progress-linear(absolute, color="secondary", indeterminate)
      v-col.justify-center.d-flex
        h5 {{ $t('chart.loading')}}
</template>
<script>
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  props: ['chart'],
  data: function () {
    return {
      isLoadingData: true
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    redirectChart ($event, chart) {
      try {
        var index = [];
        //$event.targetID example: bar#0#1
        var pieces = $event.targetID.split('#');
        var criteria = null;
        
        if(pieces.length > 2){
          index.push(pieces[1]);
          index.push(pieces[2]);
          criteria = chart.dimensionsCriterias[index[1]][index[0]];
        }
        else {
          index.push(pieces[1]);
          criteria = chart.dimensionsCriterias[index[0]][0];
        }

        let router = this.$router.resolve({name: `${this.$lcfirst(criteria.entity)}.index`});
        if (chart.customEntity) {
          this.$router.replace({ path: '/' }, () => {
            this.$router.replace({ name: 'home', params: { scope: this.$scope(), criteria: criteria.value == "" ? null : criteria }});
          });
        } else {
          if(router.resolved.matched.length > 0)
            this.$router.push({ name: `${this.$lcfirst(criteria.entity)}.index`, params: { criteria: criteria.value == "" ? null : criteria }})
          this.$router.push({ name: `entities.index`, params: { entity: criteria.entity, criteria: criteria.value == "" ? null : criteria }})
        }
      } catch (error) {
        console.log(this.$cleanString(error));
      }
    },
    async getServerChartData(id) {
      return (await axios.get("dashboards/" + id + "/data")).data;
    },
  },
  components: {
    GChart
  },
  async created () {
    this.chart.data = await this.getServerChartData(this.chart.id);
    this.isLoadingData = false;
  }
}
</script>
